<template>
  <div class="tender-block">
    <h1 class="heading">{{ $t('General information for') }} "{{ publicTenderInfo.name }}"</h1>
    <div class="tender-info">
      <div class="tender-info__column">
        <div v-if="publicTenderInfo.updated_at" class="d-contents">
          <div class="tender-info__title">
            {{ $t('Last updated') }}
          </div>
          <div class="tender-info__value">
            {{ prettyDates(publicTenderInfo.updated_at) }}
          </div>
        </div>
        <div
          v-if="publicTenderInfo.project_states[publicTenderInfo.project.state]"
          class="d-contents"
        >
          <div class="tender-info__title">
            {{ $t('Project stage') }}
          </div>
          <div class="tender-info__value capitalize">
            {{ publicTenderInfo.project_states[publicTenderInfo.project.state] }}
          </div>
        </div>
        <div v-if="publicTenderInfo.offers_deadline_date" class="d-contents">
          <div class="tender-info__title">
            {{ $t('Offers deadline') }}
          </div>
          <div class="tender-info__value">
            {{ prettyDates(publicTenderInfo.offers_deadline_date) }}
          </div>
        </div>
      </div>
      <div class="tender-info__column">
        <div v-if="publicTenderInfo.public_budget" class="d-contents">
          <div class="tender-info__title">
            {{ $t('Expected price') }}
          </div>
          <div class="tender-info__value">
            {{ currencySymbols[publicTenderInfo.project.currency] }}
            {{ addSpaces(publicTenderInfo.public_budget) }}
          </div>
        </div>
        <div v-if="publicTenderInfo.address" class="d-contents">
          <div class="tender-info__title">
            {{ $t('Execution address') }}
          </div>
          <div class="tender-info__value">
            {{ publicTenderInfo.address }}
          </div>
        </div>
        <div v-if="publicTenderInfo.construction_beginning_date" class="d-contents">
          <div class="tender-info__title">
            {{ $t('Construction begins') }}
          </div>
          <div class="tender-info__value">
            {{ prettyDates(publicTenderInfo.construction_beginning_date) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import get from 'lodash.get';
  import addSpaces from '@/utils/formatting/add-spaces';
  import prettyDates from '@/utils/formatting/pretty-date';

  export default {
    name: 'MainInfoOfPublicTender',
    computed: {
      ...mapState('publicTender', ['publicTenderInfo']),
      ...mapState('global', ['tenderStatuses', 'currencySymbols']),
    },
    methods: {
      get,
      addSpaces,
      prettyDates,
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
